import React, { Component } from "react";

export default class footer extends Component {
  render() {
    return (
      <>
        <div class="footer out-footer">
          <div class="copyright">
            <p>
              Copyright © by
              <a href="https://dicebd.com" target="_blank">
                dicebd
              </a>
              2026
            </p>
          </div>
        </div>
      </>
    );
  }
}
